import React from "react";

export default function ZPartner02Header() {
    return (
        <header className="header-main shadow-sm">
            <nav id="navbar_top" className="navbar navbar-expand-md bg-white">
                <div className="container">
                    <span className="navbar-brand col-2 col-md-1 pe-0 me-0" id="logo">
                        <img src="media/starbucks_corporation_logo.png" alt="Starbucks" className="img-fluid" />
                    </span>
                    {/*<div className="col-4 text-end"><img src="media/LM-Icon.svg" alt="LINEMAN" className="img-fluid mb-2" /></div>*/}
                </div>
            </nav>
        </header>
    );
}
